const DEFAULT_KEY = "vuex";
const BLOCKED_KEYS = new Set(["__proto__", "constructor", "prototype"]);

function mergeState(current, persisted) {
  if (Array.isArray(persisted)) return [...persisted];
  if (!persisted || typeof persisted !== "object") return persisted;

  const merged = { ...(current ?? {}) };
  Object.entries(persisted).forEach(([key, value]) => {
    if (BLOCKED_KEYS.has(key)) return;
    merged[key] = mergeState(merged[key], value);
  });
  return merged;
}

export function createPersistedState({
  key = DEFAULT_KEY,
  reducer = (state) => state,
  storage = globalThis.localStorage,
} = {}) {
  return (store) => {
    if (!storage) return;

    try {
      const savedState = storage.getItem(key);
      if (savedState) store.replaceState(mergeState(store.state, JSON.parse(savedState)));
    } catch (error) {
      console.warn("Unable to restore persisted Vuex state", error);
    }

    store.subscribe((_mutation, state) => {
      try {
        storage.setItem(key, JSON.stringify(reducer(state)));
      } catch (error) {
        console.warn("Unable to persist Vuex state", error);
      }
    });
  };
}
